import { Cookies } from 'react-cookie';

import { ObjectTraps } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getObjectTraps = async (slug: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/are-object-traps-installed/${slug}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as ObjectTraps;
};
